import { Box, Flex, Heading, SimpleGrid, Text } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { SectionHeader } from '~/components/section-header';
import { AccreditationPathStep } from '~/features/accreditation/types';
import { RocketIcon } from '~/features/experiments/ab_plp_redesign_2025/icons';

export function AccreditationPathSection({
  sectionTitle,
  description,
  steps,
}: {
  sectionTitle: string;
  description: string;
  steps: AccreditationPathStep[];
}) {
  return (
    <Flex as='section' flexDirection='column' gap='56px'>
      <ContentContainer contentMaxWidth='content-max-width-md'>
        <SectionHeader
          color='grey.500'
          containerProps={{ maxWidth: '900px', margin: '0 auto' }}
          descriptionSlot={<Text color='grey.500'>{description}</Text>}
          iconSlot={<RocketIcon color='grey.500' height='18px' width='18px' />}
          subtitle='Getting Started'
          titleSlot={
            <Heading
              as='h2'
              fontWeight='600'
              lineHeight='1.1'
              fontSize={{
                base: '2.5rem',
                md: '3.375rem',
              }}
            >
              {sectionTitle}
            </Heading>
          }
        />

        <SimpleGrid columns={{ base: 1, md: 2 }} gap={{ base: '8px', md: '16px' }} mt={{ base: '40px', md: '72px' }}>
          {steps.map((step, index) => (
            <Flex
              key={step.title}
              bg='grey.50'
              border='1px solid'
              borderColor='grey.100'
              borderRadius='4px'
              gap='24px'
              justifyContent='space-between'
              p={{ base: '14px 16px', md: '24px' }}
            >
              {step.icon}
              <Box bgGradient='linear(to-b, #EDA93B 0%, transparent 100%)' h='full' w='2px' />
              <Flex direction='column' flex={1} gap='6px'>
                <Heading as='h3' fontWeight='600' size={{ base: 'heading-9', md: 'heading-8' }}>
                  {step.title}
                </Heading>
                <Text color='grey.900' fontSize='sm'>
                  {step.description}
                </Text>
              </Flex>
            </Flex>
          ))}
        </SimpleGrid>
      </ContentContainer>
    </Flex>
  );
}
